export class ReflectorInternalError extends Error {
	public constructor() {
		super('An internal error occurred while processing the request');
	}
}
